import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=4eaa86f5&scoped=true&"
import script from "./list2.vue?vue&type=script&lang=js&"
export * from "./list2.vue?vue&type=script&lang=js&"
import style0 from "./list2.vue?vue&type=style&index=0&id=4eaa86f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa86f5",
  null
  
)

export default component.exports